import {
	getAttributeOrThrow,
	qsaOptional,
	qsaRequired,
	qsOptional,
	qsRequired,
} from '@/scripts/core/global'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class CartVariantSelect extends UcoastEl {
  static htmlSelector = 'cart-variant-select'
  select: HTMLSelectElement
  lineKey: string
  currentVariant: string
  quantity: number
  cartItem: HTMLElement | null
  ucoastSelect: HTMLElement

  constructor() {
    super()
    this.select = qsRequired('[data-variant-select]', this)
    this.ucoastSelect = qsRequired('ucoast-select', this)
    this.lineKey = getAttributeOrThrow('data-line-key', this)
    this.currentVariant = getAttributeOrThrow('data-current-variant', this)
    this.cartItem = this.closest('[data-uc-cart-item]')

    const quantityInput = this.cartItem?.querySelector('[data-uc-quantity-input]') as HTMLInputElement
    this.quantity = quantityInput ? parseInt(quantityInput.value) : 1

    // Listen for change events from UcoastSelect
    this.ucoastSelect.addEventListener('change', this.onVariantChange.bind(this))
  }

  enableLoading() {
    // Disable the select
    this.select?.setAttribute('disabled', '')

    // Show loading overlay
    if (this.cartItem) {
      const overlays = this.cartItem.querySelectorAll('[data-uc-loading-overlay]')
      overlays.forEach(overlay => overlay.classList.remove('hidden'))
    }

    // Blur active element
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur()
    }
  }

  disableLoading() {
    // Enable the select
    this.select?.removeAttribute('disabled')

    // Hide loading overlay
    if (this.cartItem) {
      const overlays = this.cartItem.querySelectorAll('[data-uc-loading-overlay]')
      overlays.forEach(overlay => overlay.classList.add('hidden'))
    }
  }

  async onVariantChange(event: CustomEvent) {
    const newVariantId = event.detail.value

    try {
      this.enableLoading()

      // First, get current cart state
      const cartResponse = await fetch('/cart.js')
      const cartData = await cartResponse.json()

      // Check if the new variant already exists in cart
      const existingItem = cartData.items.find(
        (item: any) => item.variant_id.toString() === newVariantId
      )

      const requestData = {
        updates: {
          [this.lineKey]: 0,  // Remove current variant
          [newVariantId]: this.quantity + (existingItem?.quantity || 0)  // Add quantities together
        }
      }

      console.log('Sending cart update:', requestData)

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(requestData)
      })

      if (!response.ok) {
        const errorData = await response.json()
        console.error('Cart API Error:', errorData)
        throw new Error('Cart update failed')
      }

      const updatedCartData = await response.json()
      console.log('Variant change successful!', {
        newVariantId,
        quantity: this.quantity + (existingItem?.quantity || 0),
        updatedCart: updatedCartData
      })

      // Fetch and update the cart drawer section
      const cartDrawerResponse = await fetch(`${window.routes.cart_url}?section_id=cart-drawer-items`)
      const responseText = await cartDrawerResponse.text()

      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const source = html.querySelector('cart-drawer-items')
      if (source && this.closest('cart-drawer-items')) {
        this.closest('cart-drawer-items').innerHTML = source.innerHTML
      }

    } catch (error) {
      console.error('Error updating variant:', error)
    } finally {
      this.disableLoading()
    }
  }
}

customElements.define(CartVariantSelect.htmlSelector, CartVariantSelect)